{
  "New conversation": "新建对话",
  "A lighter AI workspace": "轻盈的 AI 工作空间",
  "Close sidebar": "关闭侧栏",
  "Open sidebar": "打开侧栏",
  "Toggle sidebar": "显示或隐藏侧栏",
  "Settings": "设置",
  "Conversation": "对话",
  "Creation": "创作",
  "Account & app": "账户与应用",
  "Conversations": "对话",
  "Delete conversation": "删除对话",
  "Local-first": "本地优先",
  "History stays local; active streams resume temporarily": "历史保存在浏览器；生成流临时续传",
  "Export conversation": "导出对话",
  "Explore NeuronDeck": "了解 NeuronDeck",
  "Privacy": "隐私",
  "Terms": "条款",
  "Toggle theme": "切换主题",
  "Toggle model inspector": "打开或关闭模型参数面板",
  "Cloudflare account": "Cloudflare 账户",
  "Using your quota": "已使用你的额度",
  "Administrator connected; the workspace continues to use this site's public quota.": "管理员已登录，前台继续使用本站公共额度。",
  "Using this site's quota": "当前使用本站额度",
  "Public site quota": "本站公共额度",
  "Connect Cloudflare": "连接 Cloudflare 并进入",
  "Connecting…": "正在连接…",
  "Sign out and revoke access": "退出并撤销授权",
  "Choose the account to bill": "选择使用额度的账户",
  "Once connected, chat, image generation, speech, and file processing use Workers AI quota from your selected Cloudflare account.": "授权后，聊天、生图、语音和文件处理都会使用所选 Cloudflare 账户的 Workers AI 额度。",
  "Anonymous requests use the Cloudflare quota pool provided by this site; connecting an account switches to your own quota.": "匿名访问正在使用站点管理员提供的 Cloudflare 额度池；连接账户后将改用你的额度。",
  "PKCE authorization; tokens are encrypted server-side and never stored in your browser.": "采用 PKCE 授权；令牌经加密保存在服务端，不会写入浏览器。",
  "Cloudflare sign-in is not configured yet.": "Cloudflare 登录暂未配置。",
  "Cloudflare authorization failed. Please try again.": "Cloudflare 授权失败，请重试。",
  "NeuronDeck": "NeuronDeck",
  "Where shall we begin?": "今天，想从哪里开始？",
  "A thought. A conversation. A little room for your next idea.": "一个想法，一段对话。让灵感在这里成形。",
  "Write some code": "写一段代码",
  "Turn your next idea into something that runs.": "把一个想法，变成可以运行的代码。",
  "I want to build a small program. Ask about its purpose, runtime, inputs, and outputs first, then provide runnable code.": "我想写一个小程序。请先问我用途、运行环境和输入输出，再给出可以直接运行的代码。",
  "Create an image": "生成一张图片",
  "A few words. A whole new perspective.": "从一句描述，开始一次视觉创作。",
  "Create a fresh, refined natural-light illustration of a coffee and an open book by a window at dawn, with generous breathing room.": "为我生成一张清新精致的自然光插画：清晨窗边的一杯咖啡与一本打开的书，画面留有呼吸感。",
  "Chat freely": "随便聊聊",
  "Follow a thought. See where it takes you.": "分享灵感，或发现一个新的视角。",
  "Let's have a relaxed chat. Start with one interesting, easygoing question.": "来随便聊聊吧。请先抛出一个有趣、轻松又不费脑的问题。",
  "You": "你",
  "Generating": "生成中",
  "Recovering connection": "正在恢复连接",
  "Reasoning trace": "推理过程",
  "Copied": "已复制",
  "Copy": "复制",
  "Regenerate": "重新生成",
  "Read aloud": "朗读",
  "Pause": "暂停",
  "Resume": "继续朗读",
  "Preparing audio": "准备语音",
  "Speech generation failed. Try again shortly.": "语音生成失败，请稍后重试。",
  "This browser does not support system text-to-speech.": "当前浏览器不支持系统语音朗读。",
  "This device has no system voice matching the text language. Install that language in system settings first.": "此设备没有与文本语言匹配的系统语音，请先在系统设置中安装对应语音。",
  "Edit from here": "从这里编辑",
  "Show message time": "显示消息时间",
  "Message {0}": "给 {0} 发消息",
  "Message": "消息",
  "Stop generating": "停止生成",
  "Send message": "发送消息",
  "Add images or files": "添加图片或文件",
  "Please analyze the content I uploaded.": "请分析我上传的内容。",
  "Processing file…": "正在处理文件…",
  "Remove attachment: {0}": "移除附件：{0}",
  "Attachments": "附件",
  "Content truncated": "内容已截断",
  "This model cannot read images. Switch to a model marked Vision.": "当前模型不支持图片，请切换到标有“视觉”的模型。",
  "You can add up to 4 attachments per message.": "每条消息最多添加 4 个附件。",
  "This model has reached its image limit.": "该模型支持的图片数量已达上限。",
  "This file format is not supported.": "不支持这种文件格式。",
  "Each image must be 4 MB or smaller.": "单张图片不能超过 4 MB。",
  "Each file must be 5 MB or smaller.": "单个文件不能超过 5 MB。",
  "This attachment could not be read. Try another file.": "无法读取这个附件，请换一个文件重试。",
  "The file could not be converted. Try another file or format.": "文件内容转换失败，请换一个文件或格式重试。",
  "Models can make mistakes. 10 generations per minute per visitor.": "模型可能会出错。每位访客每分钟最多生成 10 次。",
  "Creating your image": "正在创作图片",
  "Rendering with {0}…": "由 {0} 绘制，请稍候…",
  "Image generation failed": "图片生成失败",
  "Rendered in {0}": "生图 {0}",
  "Your image is ready.": "你的图片已经创作完成。",
  "The webpage screenshot is ready.": "网页截图已经完成。",
  "Your file is ready.": "文件已经生成好了。",
  "Created in {0}": "生成 {0}",
  "Temporary download expires after 24 hours": "临时下载链接将在 24 小时后失效",
  "Download file: {0}": "下载文件：{0}",
  "Open full image": "查看原图",
  "Download image": "下载图片",
  "Web screenshot": "网页截图",
  "Captured in {0}": "截图 {0}",
  "Full page": "整页",
  "Desktop viewport": "桌面视口",
  "Mobile viewport": "移动视口",
  "Open web screenshot": "查看网页截图",
  "Download web screenshot": "下载网页截图",
  "Sources consulted: {0}": "已查阅 {0} 个来源",
  "Accessed {0}": "访问于 {0}",
  "Export cited PDF": "导出引用 PDF",
  "Creating PDF": "正在生成 PDF",
  "The research report PDF could not be created. Try again shortly.": "研究报告 PDF 生成失败，请稍后重试。",
  "Image model": "生图模型",
  "New images use the selected model; edits, variations, and multi-reference requests automatically use FLUX.2 Dev with the real source pixels.": "新图片使用所选模型；编辑、变体和多参考图会自动使用支持真实参考图的 FLUX.2 Dev。",
  "Default": "默认",
  "Image · {0}": "生图 · {0}",
  "Read responses aloud": "回复朗读",
  "Install & completion alerts": "安装与完成提醒",
  "Install NeuronDeck as a standalone app and get an alert when a generation finishes in the background.": "安装为独立应用，并在页面切到后台时提醒你生成已经完成。",
  "Install NeuronDeck": "安装 NeuronDeck",
  "Running as an installed app": "已作为应用运行",
  "Use Add to Home Screen from your browser menu": "可从浏览器的“添加到主屏幕”安装",
  "Enable completion alerts": "开启完成提醒",
  "Completion alerts enabled": "完成提醒已开启",
  "Notifications are blocked; allow them in site settings": "浏览器已阻止通知，请在网站设置中允许",
  "Completion alerts are not supported here": "此浏览器不支持完成提醒",
  "Read assistant replies aloud. Chinese uses the device voice directly; long replies read up to the first 3,000 characters.": "为 AI 回复生成语音。中文直接使用设备声线；长回复最多朗读前 3,000 个字符。",
  "Natural voice first": "自然音质优先",
  "Aura-2 for English and Spanish; device voices for Chinese and other languages": "英语和西语使用 Aura-2，中文及其他语言使用设备声线",
  "Aura-2 · Chinese uses no Cloudflare quota": "Aura-2 · 中文不消耗 Cloudflare 额度",
  "Device system voice": "设备系统语音",
  "Uses voices available on iOS, macOS, Android, and Windows": "适配 iOS、macOS、Android 和 Windows 的可用声线",
  "Free · This site does not call the Cloudflare speech API": "免费 · 本站不调用 Cloudflare 语音 API",
  "Model inspector": "模型参数",
  "Close inspector": "关闭模型参数面板",
  "Context": "上下文",
  "Input / M": "输入 / 百万",
  "Output / M": "输出 / 百万",
  "System prompt": "系统提示词",
  "Custom instructions": "自定义指令",
  "Optional: choose a response style, language, or format. Leave blank to use the defaults.": "可选：指定回复风格、语言或格式。留空使用默认设置。",
  "Temperature": "温度",
  "Precise": "精准",
  "Creative": "创意",
  "Maximum output tokens": "最大输出 Token 数",
  "Recommended {0}; selectable up to {1}": "当前模型推荐 {0}，可选上限 {1}",
  "Use recommended": "使用推荐值",
  "Capabilities": "能力",
  "text": "文本",
  "paid": "付费",
  "Browse all {0} models": "浏览全部 {0} 个模型",
  "Model": "模型",
  "The model completed without returning text.": "模型已完成请求，但没有返回文本。",
  "Generation stopped.": "生成已停止。",
  "Refreshing interrupted this text response. Existing content was kept; you can regenerate it.": "页面刷新中断了这次文字生成。已保留现有内容，你可以点击“重新生成”继续。",
  "The model could not complete this request.": "模型无法完成此请求。",
  "Request failed with status {0}.": "请求失败（状态码 {0}）。",
  "Model catalog unavailable": "模型目录暂时不可用",
  "Choose a model": "选择模型",
  "Cloudflare model library": "Cloudflare 模型库",
  "Close model picker": "关闭模型选择器",
  "Search models, providers or capabilities": "搜索模型、提供方或能力",
  "Search models": "搜索模型",
  "Model filters": "模型筛选",
  "All": "全部",
  "Reasoning": "推理",
  "Vision": "视觉",
  "Tools": "工具",
  "Paid": "付费",
  "LoRA": "LoRA",
  "Add to favorites": "添加到收藏",
  "Remove from favorites": "取消收藏",
  "No models match this search.": "没有符合条件的模型。",
  "{0} of {1} chat models": "显示 {0} / {1} 个对话模型",
  "Catalog synced {0}": "模型目录同步于 {0}",
  "In": "输入",
  "Out": "输出",
  "Too many requests. Please try again shortly.": "请求过于频繁，请稍后再试。",
  "The image task could not be saved. Please retry.": "图片任务暂时无法保存，请重试。",
  "Image cancellation is not yet confirmed. Retry stopping the task.": "图片任务尚未确认停止，请点击重试停止。",
  "Too many requests from this network. Please wait and retry.": "当前网络请求较多，请稍后重试。",
  "Too many requests. Please wait and retry.": "请求过于频繁，请稍后重试。",
  "The previous cross-conversation concurrency limit has been removed. Retry this response.": "此前的跨对话并发限制已移除，请重试此回复。",
  "The previous site budget restriction has been removed. Retry this response.": "此前的本站预算限制已移除，请重试这条回复。",
  "The quota service is temporarily unavailable. Please retry shortly.": "额度服务暂时不可用，请稍后重试。",
  "The quota service is busy. Please retry shortly.": "额度服务繁忙，请稍后重试。",
  "The model took too long to respond. Your content is preserved. Retry this request.": "模型响应超时，已保留现有内容。请重试此请求。",
  "Model output stalled. Partial content is preserved. Please retry.": "模型输出长时间没有更新，已保留部分内容。请重试。",
  "The model or account quota is busy. Retry shortly or choose another model.": "当前模型或账户额度繁忙，请稍后重试或选择其他模型。",
  "This task reached its tool limit. Continue with a smaller request.": "本次任务已达到工具使用上限，请缩小任务范围后继续。",
  "The previous task time limit has been removed. Your completed work is saved. Retry this response.": "此前的任务时长限制已移除，已完成的内容仍然保留。请重试这条回复。",
  "The connection was interrupted. Content is preserved. Reconnect the original task.": "连接暂时中断，已保留内容。可重新连接原任务。",
  "Choose a valid Cloudflare chat model.": "请选择有效的 Cloudflare 对话模型。",
  "The messages are invalid. Edit them and try again.": "消息内容无效，请修改后重试。",
  "The request is invalid. Check it and try again.": "请求参数无效，请检查后重试。",
  "Model inference failed. Try again or choose another model.": "模型推理失败，请稍后重试或更换模型。",
  "The service is temporarily unavailable. Please try again.": "服务暂时不可用，请稍后再试。",
  "This model cannot read images. Choose a vision model.": "当前模型不支持图片，请切换到视觉模型。",
  "There are too many attachments. Remove some and try again.": "附件过多，请减少后重试。",
  "There are more images than this model can process.": "图片数量超过此模型的处理上限。",
  "An attachment is too large. Compress it or remove some content.": "附件过大，请压缩或减少内容后重试。",
  "An attachment is invalid. Add it again.": "附件内容无效，请重新添加。",
  "The file could not be converted.": "文件内容转换失败。",
  "The file is too large. Compress it and try again.": "文件过大，请压缩后重试。",
  "Choose a valid Cloudflare image model.": "请选择有效的 Cloudflare 生图模型。",
  "Choose a valid Cloudflare speech model.": "请选择有效的 Cloudflare 语音模型。",
  "There is no readable text in this reply.": "没有可朗读的文字。",
  "Speech is not available for this language.": "当前语言暂不支持语音朗读。",
  "The speech text is too long. Shorten it and try again.": "朗读文字过长，请缩短后重试。",
  "Too many speech requests. Try again shortly.": "语音请求过于频繁，请稍后再试。",
  "Your Cloudflare authorization expired. Connect again.": "Cloudflare 授权已过期，请重新连接。",
  "Connect a Cloudflare account first.": "请先连接 Cloudflare 账户。",
  "This site's public Cloudflare quota is temporarily unavailable.": "本站公共 Cloudflare 额度暂时不可用，请稍后再试。",
  "This site's public AI quota is busy. Please try again shortly.": "本站公共 AI 额度正在繁忙，请稍后再试。",
  "Language": "语言",
  "Saved in this browser": "已保存到此浏览器",
  "Saving…": "正在保存…",
  "Saving failed. Current changes are only in this page. Retry or download a backup first.": "保存失败，当前更改仅保留在页面中。请重试或先下载备份。",
  "Local history could not be read. Automatic saving is paused to protect existing data. Close older tabs and reload.": "无法读取本地历史，已暂停自动保存以保护原数据。请关闭其他旧标签页后重新载入。",
  "Another tab updated the history. Back up this page's changes, then reload to avoid overwriting them.": "另一标签页已更新历史。请先备份本页更改，再重新载入，避免覆盖其他内容。",
  "Retry saving": "重试保存",
  "Reload": "重新载入",
  "Back up workspace": "备份工作区",
  "Import backup": "导入备份",
  "Preparing backup…": "正在打包备份…",
  "Backup failed. Please try again.": "备份失败，请重试。",
  "Backup downloaded; {0} temporary files or images could not be downloaded. Their original links are retained.": "备份已下载；{0} 个临时文件或图片无法下载，备份中保留了原链接。",
  "Backup downloaded with conversations, drafts, and available attachments.": "备份已下载，包含对话、草稿和可用附件。",
  "Imported {0} conversation copies. Existing conversations are preserved.": "已导入 {0} 个对话副本，现有对话已保留。",
  "Import failed. Choose a valid NeuronDeck workspace backup (up to 100 MB).": "无法导入：请选择有效的 NeuronDeck 工作区备份（最多 100 MB）。",
  "Cancel edit": "取消编辑",
  "{0} · Branch": "{0} · 分支",
  "Context ≈ {0} / {1} tokens": "上下文约 {0} / {1} Token",
  "{0} earlier messages will become history excerpts": "{0} 条较早消息将整理为历史摘录",
  "This message or its attachments exceed the available context. Shorten the content, remove attachments, or choose a larger-context model.": "当前消息或附件超过模型可用上下文，请缩短内容、减少附件或切换到更大上下文模型。",
  "The system prompt exceeds the available context. Shorten it or choose a larger-context model.": "系统提示词超过模型可用上下文，请缩短提示词或切换模型。",
  "Jump to latest": "回到最新",
  "Generation incomplete": "生成未完成",
  "Draft saved with conversation": "草稿随对话保存",
  "Conversations and drafts stay in this browser. Backups import as copies and include temporary images and files that are still available.": "对话和草稿保存在此浏览器。备份可导入为副本；仍有效的临时图片和文件会一并打包。",
  "All models": "全部模型",
  "Favorites": "我的收藏",
  "Recent": "最近使用",
  "Model collection": "模型分组",
  "Use case": "使用场景",
  "Sort": "排序",
  "Everyday chat": "日常对话",
  "Coding": "编程",
  "Images": "看图",
  "All models support text chat. Favorites appear first in the default order.": "全部模型均支持文字对话；默认顺序下收藏优先。",
  "Models explicitly tagged for coding in the catalog.": "只显示模型目录中明确标注编程能力的模型。",
  "Models that support image input.": "只显示支持图片输入的模型。",
  "Default order": "默认顺序",
  "Recently used first": "最近使用优先",
  "Output price: low to high": "输出价格：低到高",
  "Output price: high to low": "输出价格：高到低",
  "Input price: low to high": "输入价格：低到高",
  "Input price: high to low": "输入价格：高到低",
  "Show details": "查看详情",
  "Hide details": "收起详情",
  "Cached input": "缓存输入",
  "Prices per million tokens": "价格按每百万 token 计费",
  "Recently used": "最近使用",
  "Selected": "当前选择",
  "No favorites yet. Star a model to find it here next time.": "还没有收藏。点击模型旁的星标，之后可以在这里快速找到。",
  "No recent models yet. Models appear here after you select and use them.": "还没有使用记录。选择并使用一个模型后，它会出现在这里。",
  "No models match these filters. Try clearing them.": "这些条件下没有匹配模型。试试清除筛选。",
  "Clear filters": "清除筛选",
  "Back to workspace": "返回工作台",
  "Site admin": "站点后台",
  "Model health & cost center": "模型健康与成本中心",
  "Success rate, time to first token, full latency, tokens, and estimated cost by model for the last 30 days, plus anonymous traffic.": "查看最近 30 天各模型的成功率、首字延迟、完整耗时、Token 与估算成本，同时保留匿名访问概览。",
  "Refresh data": "刷新数据",
  "AI model requests": "AI 模型请求",
  "Overall success rate": "整体成功率",
  "Average first token": "平均首字耗时",
  "Estimated chat cost": "估算聊天成本",
  "Model health detail": "模型健康明细",
  "Health · 30 days": "Health · 30 days",
  "Type": "类型",
  "Status": "状态",
  "Requests": "请求",
  "Success": "成功率",
  "Avg duration": "平均总耗时",
  "Input / output tokens": "输入 / 输出 Token",
  "Tool calls": "工具调用",
  "Est. cost": "估算成本",
  "Healthy": "健康",
  "Observing": "观察中",
  "Degraded": "波动",
  "Incident": "异常",
  "Chat": "聊天",
  "Image": "生图",
  "Speech": "语音",
  "Web": "网页",
  "The new metrics begin accumulating with this release. Complete a few generations to populate model health.": "新计量会从本次升级后开始累计，完成几次生成后即可看到模型健康数据。",
  "Costs use published input, cached-input, and output token prices in the model catalog. Image, speech, and the final Cloudflare bill remain authoritative in the dashboard.": "成本仅按模型目录中的公开输入、缓存输入与输出 Token 单价估算；图片、语音及 Cloudflare 最终账单以控制台为准。",
  "Anonymous traffic & feature usage": "匿名访问与功能用量",
  "Only hashed random browser IDs and aggregate counters are stored; conversation content is not collected.": "只统计随机浏览器标识的哈希与聚合计数，不保存对话内容。",
  "Unique browsers": "独立浏览器",
  "Active today": "今日活跃",
  "Active in 7 days": "近 7 天活跃",
  "Active in 30 days": "近 30 天活跃",
  "Deduplicated by a random browser identifier; not registered people": "按随机浏览器标识去重，不代表实名用户数",
  "14-day activity": "近 14 天活跃趋势",
  "Page visits": "页面访问",
  "Chat requests": "聊天请求",
  "Images created": "成功生图",
  "Speech created": "成功语音",
  "Generation errors": "生成错误",
  "Last 30 days": "最近 30 天明细",
  "Date (UTC)": "日期（UTC）",
  "Loading dashboard data…": "正在读取后台数据…",
  "Administrator Cloudflare account required": "需要管理员 Cloudflare 账户",
  "Connect the Cloudflare account that owns this site. Regular user accounts cannot read these statistics.": "连接站点所属的 Cloudflare 账户后即可进入后台。普通用户账户无法读取统计数据。",
  "This account has no dashboard access": "当前账户没有后台权限",
  "Switch or reconnect to the site administrator Cloudflare account from the main workspace.": "请在主界面切换或重新连接站点管理员的 Cloudflare 账户。",
  "The dashboard is not configured": "后台尚未配置完成",
  "Set the ADMIN_ACCOUNT_ID Secret and bind the METRICS_DB D1 database for this deployment.": "需要为部署设置 ADMIN_ACCOUNT_ID Secret，并绑定 METRICS_DB D1 数据库。",
  "Statistics are temporarily unavailable": "暂时无法读取统计",
  "Try again": "重试",
  "Only SHA-256 hashes of random browser IDs and aggregate model metrics are stored. Message content, IPs, filenames, and Cloudflare tokens are never recorded.": "只保存随机浏览器 ID 的 SHA-256 哈希及聚合模型指标；不记录消息内容、IP、文件名或 Cloudflare Token。",
  "Updated {0}": "更新于 {0}",
  "Data will appear after people visit and use AI features.": "数据会在用户访问和使用 AI 功能后出现在这里。",
  "Model health & cost center · NeuronDeck": "模型健康与成本中心 · NeuronDeck",
  "Conversation exported": "对话已导出",
  "local resources": "个本地资源",
  "Storage usage is unavailable": "暂时无法获取存储用量",
  "Cleanup failed. Your saved history is unchanged.": "清理失败，已有记录保持不变。",
  "Undo": "撤销",
  "Dismiss": "关闭提示",
  "Resources and offline export": "对话资源与离线导出",
  "Site information": "站点信息",
  "Could not load this conversation. It is still saved locally.": "对话加载失败，记录仍保留在本机。",
  "Retry": "重试",
  "Loading conversation…": "正在加载对话…",
  "Load earlier messages ({0} remaining)": "加载更早消息（还有 {0} 条）",
  "Retry after: ": "可重试时间：",
  "Retry stopping": "重试停止",
  "Account and quota": "管理账户与额度",
  "Choose another model": "选择其他模型",
  "Reconnect task": "重新连接任务",
  "Some resources are not saved locally. View details": "有资源尚未保存到本机，查看详情",
  "Dismiss failed attachment": "移除失败附件",
  "Image generation requires a model with tools. Select a model labeled Tools.": "生图需要支持工具的模型，请先选择标有「工具」的模型。",
  "Conversation resources": "对话资源",
  "Close resources": "关闭资源面板",
  "Export offline HTML with resources": "导出离线 HTML（含资源）",
  "Saving resources to this device…": "正在保存资源到本机…",
  "{0} resources could not be saved. Temporary links may expire.": "{0} 个资源暂未保存，临时链接过期后将无法取回。",
  "This conversation has no attachments or generated resources yet.": "这段对话还没有附件或生成资源。",
  "Generated images and files are automatically saved to this device.": "生成的图片和文件会自动保存到此设备。",
  "Clean unused resources": "清理未使用资源",
  "Temporary screenshot, not saved locally": "临时截图，尚未保存在本地",
  "Pinned": "置顶",
  "Today": "今天",
  "Yesterday": "昨天",
  "Earlier": "更早",
  "Conversation actions": "对话操作",
  "Rename": "重命名",
  "Unpin": "取消置顶",
  "Pin": "置顶",
  "Restore": "恢复对话",
  "Delete permanently": "永久删除",
  "Search conversations": "搜索对话内容",
  "Clear search": "清空搜索",
  "Chats": "对话",
  "Conversation history": "对话记录",
  "Searching…": "正在搜索…",
  "No matching conversations": "没有匹配的对话",
  "No conversations here": "这里还没有对话",
  "{0} versions": "{0} 个版本",
  "Rename conversation": "重命名对话",
  "Delete conversation permanently": "永久删除对话",
  "Delete this conversation permanently?": "永久删除这段对话？",
  "Conversation name": "对话名称",
  "Cancel": "取消",
  "Save": "保存",
  "Parent chat": "来源对话",
  "Original chat": "原始对话",
  "Version": "版本",
  "Switch conversation version": "切换对话版本",
  "Temporary download link": "临时下载链接",
  "Temporary image, not saved locally": "临时图片，尚未保存在本地",
  "Searching the web": "正在搜索网页",
  "Reading webpage": "正在读取网页",
  "Capturing webpage": "正在截取网页",
  "Web tool unavailable": "网页工具暂时不可用",
  "Sources consulted": "已查阅来源",
  "Attachment": "附件",
  "Image is not saved locally. Use offline HTML export to embed available resources.": "图片尚未保存在本地，请使用离线 HTML 导出以保存可用资源。",
  "temporary resource; export offline HTML": "临时资源，请导出离线 HTML",
  "Sources": "来源",
  "Read document text": "查看文档文字",
  " (excerpt)": "（已截取）",
  "File could not be saved": "文件未能保存",
  "Offline conversation archive": "离线对话存档",
  "{0} resources could not be embedded. The conversation text is preserved.": "{0} 个资源未能保存，文字记录仍完整保留。",
  "Could not check the image job.": "无法查询生图任务。",
  "Image generation failed.": "图片生成失败。",
  "Image generation is taking too long. Check back later.": "生图时间过长，请稍后返回查看。",
  "Context n/a": "上下文未知",
  "NeuronDeck generation complete": "NeuronDeck 已生成完成",
  "The model response is ready.": "模型回复已经完成。",
  "Saved on this device": "已保存在此设备",
  "Download expiry unknown": "下载期限未知",
  "Temporary file expired": "临时文件已过期",
  "{0}s": "{0} 秒",
  "{0}m {1}s": "{0} 分 {1} 秒",
  "Stop was not confirmed. Please try again.": "尚未确认停止，请重试。",
  "Access time not recorded": "访问时间未记录",
  "Accessed": "访问于",
  "The chat model did not provide a valid image prompt.": "聊天模型没有提供有效的绘图描述。",
  "Too many image requests. Please try again shortly.": "生图请求过于频繁，请稍后再试。",
  "This turn allows at most {0} image attempts, including failure recovery.": "本轮最多允许 {0} 次生图尝试，失败补偿次数已经用完。",
  "The requested tool actions completed and their results are shown above.": "请求中的工具操作已经完成，结果已显示在上方。",
  "The model could not complete this tool request. Try again or choose another tool-capable model.": "模型未能完成这次工具请求，请重试或换一个支持工具调用的模型。",
  "The image was not generated. Try again or choose a different image model.": "图片没有生成成功，请稍后重试或更换生图模型。",
  "The best balance of speed and quality for everyday creation": "速度与画质最均衡，适合日常创作",
  "$0.015 / first megapixel": "$0.015 / 首个百万像素",
  "Prioritizes detail and realism with a slower render": "细节与真实感优先，生成速度较慢",
  "Priced by tile and step": "按图块与步数计费",
  "Excellent for visual design, product shots, and text": "擅长视觉设计、产品图与画面文字",
  "$0.007 / 512px tile": "$0.007 / 512px 图块",
  "Strong prompt adherence with coherent rendered text": "提示词遵循出色，也善于生成连贯文字",
  "$0.0058 / 512px tile": "$0.0058 / 512px 图块",
  "Production-grade open-weight reasoning model for general and agentic work.": "适合通用任务与智能体工作的生产级开放权重推理模型。",
  "Small LoRA-capable Gemma instruction model.": "体积小巧、支持 LoRA 的 Gemma 指令模型。",
  "Lightweight multilingual dialogue and summarization model.": "适合轻量对话与摘要的多语言模型。",
  "LoRA-capable instruction-tuned Mistral model.": "支持 LoRA 的 Mistral 指令微调模型。",
  "Code-optimized frontier model for long-horizon coding and agentic tasks.": "面向长程编程与智能体任务优化的前沿代码模型。",
  "Distilled reasoning model for difficult analytical and mathematical work.": "适合复杂分析与数学任务的蒸馏推理模型。",
  "Balanced, quantized instruction model for everyday conversation.": "适合日常对话的均衡型量化指令模型。",
  "Z.ai's flagship agentic coding model with a long context window, reasoning, function calling, and structured outputs for multi-step development workflows.": "智谱旗舰级智能体编程模型，支持超长上下文、推理、工具调用和结构化输出，适合多步骤开发任务。",
  "The first natively multimodal model in the GLM-5 series. With 320B total parameters and just 18B active parameters, it outperforms GLM-5.2 across benchmarks and real-world workloads at one-tenth the price, while approaching Claude Opus 4.8 on coding and agentic benchmarks.": "拥有超长上下文、视觉理解和工具调用能力的高性价比旗舰级 MoE 模型。",
  "Very fast multilingual model for lightweight dialogue tasks.": "适合轻量对话任务的高速多语言模型。",
  "Frontier-scale multimodal model for long-context reasoning and tool use.": "支持长上下文推理与工具调用的前沿多模态模型。",
  "Fast multilingual dialogue and instruction model with multi-turn tool calling.": "支持多轮工具调用的高速多语言对话与指令模型。",
  "LoRA-capable Llama 2 model optimized for dialogue.": "支持 LoRA、面向对话优化的 Llama 2 模型。",
  "Fast FP8 Llama model for high-quality instruction following.": "兼顾速度与高质量指令遵循的 FP8 Llama 模型。",
  "Compact instruction model tuned for function calling and agent workflows.": "为函数调用和智能体工作流调优的紧凑指令模型。",
  "Long-context DeepSeek model tuned for fast reasoning and agentic use.": "面向高速推理与智能体任务的长上下文 DeepSeek 模型。",
  "Code-specific instruction model for generation, review and debugging.": "面向代码生成、审查和调试的专用指令模型。",
  "Flagship reasoning and agentic coding model from Z.ai.": "智谱旗舰级推理与智能体编程模型。",
  "Hybrid MoE reasoning model built for agentic AI systems.": "为智能体 AI 系统打造的混合 MoE 推理模型。",
  "Instruction model specialized for Southeast Asian languages.": "专注东南亚语言的指令模型。",
  "Efficient MoE model for multilingual reasoning and instruction following.": "适合多语言推理与指令遵循的高效 MoE 模型。",
  "LoRA-capable Gemma instruction model.": "支持 LoRA 的 Gemma 指令模型。",
  "Google's high-intelligence open multimodal model with a long context window.": "拥有长上下文能力的 Google 高智能开放多模态模型。",
  "Efficient long-context instruction model with strong text performance.": "文本能力出色的高效长上下文指令模型。",
  "High-capability reasoning model for long-horizon and complex multi-step work.": "适合长程与复杂多步骤工作的高能力推理模型。",
  "Vision instruction model for image reasoning, captioning and conversation.": "适合图像推理、描述和对话的视觉指令模型。",
  "Multimodal instruction model for general text, reasoning and agentic workloads.": "适合通用文本、推理和智能体工作的多模态指令模型。",
  "Lower-latency open-weight model for reasoning and specialized tasks.": "面向推理与专业任务的低延迟开放权重模型。",
  "Natively multimodal Mixture-of-Experts model for text and image understanding.": "用于文本和图像理解的原生多模态 MoE 模型。",
  "Reasoning-focused Qwen model for hard multi-step problems.": "专注高难度多步骤问题的 Qwen 推理模型。",
  "{0} context": "{0} 上下文",
  "Expires in {0}": "{0}后过期",
  "No previous image is available to edit. Generate or attach a reference image first.": "没有找到可编辑的上一张图片，请先生成或上传一张参考图。",
  "The selected image model could not complete the request. Try again or choose another model.": "所选生图模型暂时无法完成请求，请稍后重试或更换模型。",
  "This page needs a refresh": "页面需要重新载入",
  "The interface hit an unexpected error. Your conversations are still stored in this browser.": "界面遇到意外错误。你的对话仍保存在此浏览器中。",
  "Could not load this language. Try again.": "语言加载失败，请重试。",
  "Resource unavailable": "资源不可用",
  "Operations": "运行状况",
  "Traffic": "访问",
  "Activity": "活跃情况",
  "Usage": "用量",
  "Daily": "每日",
  "The output limit was reached before the answer finished. Reasoning counts toward this limit. Increase the output limit in settings and retry.": "已达到输出上限，答案尚未完成。思考也会占用此额度，请在设置中提高输出上限后重试。",
  "The model ended without a final answer. Its reasoning is preserved. Increase the output limit or try another model.": "模型结束了生成，但未给出最终答案。思考内容已保留，请提高输出上限或尝试其他模型。",
  "The model provider stopped this response. Edit the request or choose another model.": "模型提供方中止了此次回复。请修改请求或选择其他模型。",
  "Adjust output limit": "调整输出上限",
  "This limit includes both reasoning and the final answer. Long tasks may need a higher limit.": "此上限包含思考和最终答案。处理长文本时，可能需要提高额度。",
  "Showing recent reasoning while generating. The full text is saved.": "生成时仅显示最近的思考，完整内容已保留。",
  "Reasoning effort": "推理强度",
  "Model default": "跟随模型默认",
  "Off": "关闭",
  "Low": "低",
  "High": "高",
  "Maximum": "最高",
  "Uses the model's default unless you choose a level. Applies to the next response.": "未手动选择时保持模型默认强度，调整后从下一次回复生效。",
  "Automatic output": "智能输出",
  "Output capacity adapts to the model and available context. Long answers continue automatically when possible.": "根据模型能力和剩余上下文自动分配输出空间，长回答会在可行时自动续写。",
  "Context managed automatically": "上下文自动管理",
  "Organizing conversation context…": "正在整理对话上下文…",
  "Continuing the answer…": "正在继续回答…",
  "The model reached its output capacity after automatic recovery. Your partial answer is saved. Retry or choose another model.": "自动恢复后仍达到模型输出上限。已保留部分回答，请重试或选择其他模型。",
  "The model ended without a final answer. Its reasoning is preserved. Retry or choose another model.": "模型未给出最终回答，已保留思考内容。请重试或选择其他模型。",
  "Context could not be summarized. Your original messages are saved. Please retry.": "上下文摘要生成失败，原始消息已保留。请重试。",
  "Could not delete the server conversation. Your local history is kept. Please retry.": "无法删除服务端对话，已保留本地历史。请重试。",
  "Conversation originals are stored on this device and on the server for context recovery. Permanent deletion also clears server conversation memory.": "对话原文保存在此设备和服务端，用于上下文恢复。永久删除对话也会清除服务端对话记忆。",
  "Estimated input for this request. Actual tokenization varies. Earlier conversation is summarized automatically on the server; original messages remain available.": "本次请求的估算输入量，实际分词可能不同。较早对话会在服务端自动摘要，原始消息仍可查阅。",
  "Server context needs to be restored. Retry this response to upload the local history again.": "服务端上下文需要恢复。请重试此回复，重新同步本地历史。",
  "A response is already running in this conversation. Wait for it to finish or stop it.": "此对话已有回复正在生成，请等待完成或先停止。",
  "A tool finished, but its recovery record could not be saved. Completed resources are preserved.": "工具已完成，但恢复记录保存失败。已生成的资源会保留。",
  "Generated by NeuronDeck on": "由 NeuronDeck 生成于",
  "Running script": "正在运行脚本",
  "Script completed": "脚本已完成",
  "Script interrupted or failed": "脚本已中断或失败",
  "Executed code": "执行代码",
  "Script output": "脚本输出",
  "Script diagnostics": "脚本诊断",
  "Only an output preview is shown. Check the exported file; partial files are marked in their name.": "这里只显示输出预览，请查看导出文件；未完整捕获的文件名带有 partial 标记。",
  "Model output paused. Automatically retrying with saved progress…": "模型输出已暂停，正在保留已有进度并自动重试…",
  "No new model output for {0}s. Checking the connection…": "已有 {0} 秒没有新输出，正在检查连接…",
  "Preparing a tool call…": "正在准备工具调用…",
  "Waiting for the model…": "正在等待模型响应…",
  "Available in this browser": "已缓存在此浏览器",
  "Save file": "保存文件",
  "Preparing file…": "正在准备文件…",
  "File could not be prepared. The link may have expired or the connection failed. Try again.": "无法准备文件，可能是链接已过期或网络连接失败。请重试。",
  "Choose where to save in the system panel.": "请在系统面板中选择保存位置。",
  "System panel closed. If you saved the file, find it in the folder you selected.": "系统面板已关闭。如果你已保存文件，请到所选文件夹中查找。",
  "Save cancelled. You can try again.": "已取消保存，可以重试。",
  "Could not open the system save panel. Try again or use browser download.": "无法打开系统保存面板，请重试或使用浏览器下载。",
  "Download requested. Check your browser's downloads; this page cannot confirm that the file was saved.": "已请求下载。请查看浏览器的下载列表；网页无法确认文件是否已保存。",
  "File opened in a new tab. In Safari, use Share → Save to Files.": "已在新标签页打开文件。在 Safari 中选择“分享”→“存储到文件”。",
  "File ready. Choose how to save it.": "文件已就绪，请选择保存方式。",
  "On iPhone, choose Save to Files in the system panel, select a folder, then tap Save.": "在 iPhone 系统面板中选择“存储到文件”，选好文件夹后点“存储”。",
  "Save or share…": "保存或分享…",
  "Browser download": "浏览器下载",
  "Open file": "打开文件",
  "On iPhone, browser downloads are in Files → Browse → Downloads, under iCloud Drive or On My iPhone, depending on Safari settings.": "在 iPhone 的“文件”→“浏览”中查找“下载项”文件夹；它位于 iCloud 云盘或“我的 iPhone”中，取决于 Safari 设置。",
  "Close": "关闭",
  "Running": "运行中",
  "Baseline saved": "已建立基线",
  "No change": "没有变化",
  "Changes found": "发现变化",
  "Completed": "已完成",
  "Failed": "失败",
  "Cancelled": "已取消",
  "Check the title, instructions, URLs and schedule.": "请检查任务名称、指令、网址和时间安排。",
  "This task is already running.": "此任务正在运行。",
  "Scheduled tasks are unavailable on this deployment.": "当前部署尚未启用定时任务。",
  "On iPhone, add this site to your Home Screen and open it there to enable push notifications.": "在 iPhone 上，请先将此网站添加到主屏幕，再从主屏幕打开以启用推送。",
  "Notifications were not enabled. You can allow them in browser settings.": "未启用通知。你可以在浏览器设置中允许通知。",
  "System notifications are not configured. Results remain available here.": "系统通知尚未配置。结果仍会保存在这里。",
  "This page is too large to monitor completely. Choose a more specific page.": "此网页太大，无法完整监测。请选择更具体的页面。",
  "Scheduled tasks": "定时任务",
  "Run in the background. Get notified when there is something new.": "后台持续执行，有新结果时提醒你。",
  "Could not complete the request. Please try again.": "操作未完成，请重试。",
  "Task name": "任务名称",
  "For example: Watch product updates": "例如：关注产品更新",
  "Task type": "任务类型",
  "Watch webpages for changes": "监测网页变化",
  "Scheduled AI report": "定时 AI 报告",
  "Webpage URLs (one per line)": "网页地址（每行一个）",
  "What changes matter? (optional)": "关心哪些变化？（可选）",
  "What should the AI do?": "希望 AI 做什么？",
  "For example: Only notify me about new releases, not layout changes.": "例如：只提醒新版本发布，忽略页面布局变化。",
  "For example: Summarize today’s AI news and include sources.": "例如：汇总今天的 AI 新闻，并附上来源。",
  "The first check saves a baseline without notifying. Leave the filter empty to watch all text changes.": "首次检查只建立基线，不发送提醒。留空筛选条件即可监测所有文本变化。",
  "Each completed report appears in the history and can send a notification.": "每份完成的报告都会保存在历史记录中，也可发送通知。",
  "Frequency": "执行频率",
  "Every few hours": "每隔几小时",
  "Weekly": "每周",
  "Interval in hours": "间隔小时数",
  "Time": "时间",
  "Day of week": "星期几",
  "Time zone": "时区",
  "Next run: {0}": "下次执行：{0}",
  "Saving edits stops the current run. Tasks use the Cloudflare access available when saved.": "保存修改会停止当前运行。任务使用保存时可用的 Cloudflare 访问权限。",
  "Save task": "保存任务",
  "Run now": "立即执行",
  "Delete task": "删除任务",
  "Delete this task and its execution history?": "删除此任务及全部执行记录？",
  "Execution history": "执行记录",
  "No runs yet. You can run this task now.": "暂无执行记录。可以立即运行此任务。",
  "Push delivery failed. The result is saved here.": "推送发送失败。结果已保存在这里。",
  "Load earlier runs": "加载更早的记录",
  "New task": "新建任务",
  "Let tasks keep working for you": "让任务持续为你工作",
  "Watch a release page, track a price, or receive a daily report.": "关注版本发布、追踪价格，或接收每日报告。",
  "Paused": "已暂停",
  "Turn off task notifications": "关闭任务通知",
  "Enable task notifications": "开启任务通知",
  "Results are always saved here. On iPhone, add to Home Screen and open the app there to enable system notifications.": "结果会一直保存在这里。iPhone 需添加到主屏幕并从那里打开，才能开启系统通知。",
  "Tasks belong to this browser. Save their settings before clearing website data.": "任务属于此浏览器。清除网站数据前请记下任务设置。",
  "The background run was interrupted. The next scheduled run will still happen.": "后台执行中断。下次仍会按计划执行。",
  "A scheduled task needs your attention.": "有一项定时任务需要你查看。",
  "A scheduled task has a new result.": "有一项定时任务产生了新结果。",
  "Baseline saved. Future checks will only notify you about changes.": "基线已保存。后续检查仅在发现变化时提醒你。",
  "No changes found.": "未发现变化。",
  "Page content changed.": "网页内容发生变化。",
  "Added": "新增",
  "Removed": "移除",
  "Back": "返回",
  "Edit": "编辑",
  "Loading…": "加载中…",
  "Refresh": "刷新",
  "Resume task": "恢复任务",
  "Only once": "仅运行一次",
  "Run date": "执行日期",
  "Finished: {0}": "已结束：{0}",
  "Run again": "再次运行",
  "Choose a future date and time that exists in the selected time zone.": "请选择所选时区中有效的未来日期和时间。",
  "This one-time task has finished. Edit its date and time to schedule it again.": "此单次任务已结束。修改日期和时间可重新安排。",
  "Saves a baseline now, checks once at the selected time, then stops.": "现在保存基线，在指定时间检查一次，随后结束。",
  "Runs once at the selected time, then stops. Run now completes it early.": "在指定时间运行一次后结束。点击“立即运行”会提前执行并结束。",
  "The background run was interrupted. You can retry it from the task history.": "后台运行已中断。你可以在任务历史中重试。",
  "Task created": "任务已创建",
  "View task: {0}": "查看任务：{0}",
  "Scheduled for: {0}": "已安排：{0}",
  "Results appear in Scheduled tasks. Enable task notifications there to receive alerts.": "结果会保存在“定时任务”中。如需接收提醒，请在那里开启任务通知。",
  "Task created. Open it to view or change the schedule.": "任务已创建。打开任务即可查看或修改执行安排。",
  "Every {0} hours": "每 {0} 小时",
  "Cloud browser": "云端浏览器",
  "Take control whenever you want. AI pauses while you operate this cloud browser.": "你可以随时主动接管。操作期间，AI 会暂停。",
  "Take control": "主动接管",
  "Return to AI and continue": "交还给 AI 并继续",
  "End browser session": "结束浏览会话",
  "Webpage address": "网页地址",
  "Open": "打开",
  "This cloud browser has its own login state. Return control when finished. Previous control connections disconnect automatically. Inactive sessions expire after 10 minutes.": "云端浏览器有独立的登录状态。操作完成后请交还控制权，之前的操作连接会自动断开。闲置 10 分钟后会话会过期。",
  "Choose a model with tool support before handing the browser back to AI.": "请先选择支持工具调用的模型，再将浏览器交还给 AI。",
  "Live browser view": "浏览器实时画面",
  "Live view disconnected. Refresh the view to reconnect.": "实时画面已断开，请刷新画面重新连接。",
  "Connecting to live view…": "正在连接实时画面…",
  "Scroll up": "向上滚动",
  "Scroll down": "向下滚动",
  "Next field": "下一个输入框",
  "Press Enter": "按回车键",
  "Backspace": "退格",
  "Click a field in the page, then type here": "先点击网页中的输入框，再在这里输入",
  "Type into page": "输入到网页",
  "Browser not started": "浏览器尚未启动",
  "Starting browser…": "正在启动浏览器…",
  "AI can browse": "AI 可以操作浏览器",
  "You have control": "你正在控制浏览器",
  "Browser closed": "浏览器已关闭",
  "Browser session expired": "浏览会话已过期",
  "Browser unavailable": "浏览器暂不可用",
  "Browser capacity is busy. Please try again shortly.": "浏览器资源繁忙，请稍后重试。",
  "Browser session expired. Open a new session to continue.": "浏览会话已过期，请打开新会话继续。",
  "Browser control changed. Refresh its state and try again.": "浏览器控制权已改变，请刷新状态后重试。",
  "You have control. Return it to AI when finished.": "你正在控制浏览器，完成后请交还给 AI。",
  "Could not connect to the cloud browser. Please try again.": "无法连接云端浏览器，请重试。",
  "Refresh live view": "刷新实时画面",
  "View browser": "查看浏览器",
  "I have returned browser control. Read the current page and continue my previous task.": "我已交还浏览器控制权。请读取当前页面，继续我之前的任务。",
  "Default extensions": "默认扩展",
  "Chromium desktop": "Chromium 桌面",
  "Disconnected": "连接已断开",
  "Actual size": "原始大小",
  "Fit to screen": "适应屏幕",
  "Drag to pan": "拖动平移",
  "Show keyboard": "显示键盘",
  "Paste text": "粘贴文字",
  "Full screen": "全屏",
  "Remote keyboard": "远程键盘",
  "Paste into the selected field": "粘贴到当前选中的输入框",
  "Preparing cloud browser…": "正在准备云端浏览器…",
  "Session extensions": "当前会话的扩展",
  "Loaded": "已加载",
  "Installing…": "正在安装…",
  "Extension could not load": "扩展加载失败",
  "Enter a Chrome Web Store link or a 32-character extension ID.": "请输入 Chrome 网上应用店链接或 32 位扩展 ID。",
  "This ZIP does not contain a valid extension.": "此 ZIP 中没有有效的扩展。",
  "This Chromium version requires Manifest V3 extensions.": "当前 Chromium 版本要求扩展使用 Manifest V3。",
  "Choose a ZIP file no larger than 50 MB.": "请选择不超过 50 MB 的 ZIP 文件。",
  "This extension is already in your list.": "此扩展已在列表中。",
  "Enabled extensions load in every new cloud browser. Changes apply to the next session.": "每次新建云端浏览器都会加载已启用的扩展。修改在下次会话生效。",
  "Could not save extensions. Please try again.": "扩展设置保存失败，请重试。",
  "Extension settings saved": "扩展设置已保存",
  "ZIP extension": "ZIP 扩展",
  "Chrome Web Store": "Chrome 网上应用店",
  "View in store": "在商店中查看",
  "Enable": "启用",
  "No default extensions yet": "暂未添加默认扩展",
  "Store link or extension ID": "商店链接或扩展 ID",
  "Extension name (optional)": "扩展名称（可选）",
  "Add store extension": "添加商店扩展",
  "Upload ZIP extension": "上传 ZIP 扩展",
  "ZIP files must contain manifest.json and use Manifest V3. Maximum upload: 50 MB. Settings belong to this device; browser login data is temporary.": "ZIP 必须包含 manifest.json，且使用 Manifest V3。最大上传 50 MB。配置归属于当前设备；浏览器登录状态是临时的。",
  "Delete": "删除",
  "Address bar": "地址栏",
  "New tab": "新标签页",
  "Select all": "全选",
  "Removed {0} unused resources.": "已清理 {0} 个未使用资源。",
  "This deletes the conversation from this browser and the server. This cannot be undone.": "这会删除此浏览器和服务器中的该对话，无法撤销。",
  "Editing an earlier message. Sending replaces this message and the replies after it.": "正在编辑旧消息，发送后会替换该消息及其后的回复。",
  "Copy and paste normally with ⌘/Ctrl+C and ⌘/Ctrl+V. Text syncs while you control this browser.": "直接使用 ⌘/Ctrl+C、⌘/Ctrl+V 复制粘贴，接管期间同步文本。",
  "Copied to this computer": "已复制到本地电脑",
  "Pasted into the cloud browser": "已粘贴到云浏览器",
  "Clipboard access was blocked. Allow clipboard access or press Copy again in the cloud browser.": "剪贴板访问被阻止。请允许剪贴板权限，或在云浏览器中再次按复制快捷键。",
  "Clipboard sync failed. Please try copying or pasting again.": "剪贴板同步失败，请重新复制或粘贴。",
  "Connection interrupted. Reconnecting automatically…": "连接已中断，正在自动重连…",
  "You are offline. The browser will reconnect when the network returns.": "当前网络已断开，网络恢复后将自动重连。",
  "Waiting for network. Your task will reconnect automatically.": "等待网络恢复，将自动重新连接任务。",
  "Reconnecting to the original task…": "正在重新连接原任务…",
  "The server task was interrupted. Completed output is preserved; retry or continue the conversation.": "服务端任务已中断，已完成的内容已保留。可重试或继续对话。",
  "You are an accurate, thoughtful, direct assistant. Prioritize the user’s specific request, use clear formatting, and be candid about uncertainty. Do not refuse ordinary requests merely because they concern people, public figures, or publicly available photos; do not add unrelated restrictions or moralizing. Distinguish finding existing material from generating new content. Describe actual tool capabilities, results, and provider restrictions accurately; never invent policies, sources, or successful outcomes.": "你是一位准确、周到、直接的助手。优先完成用户的具体请求，使用清晰的格式，并坦诚说明不确定之处。不要仅因话题涉及人物、公众人物或普通公开照片而拒绝，也不要自行添加无关限制或说教。区分查找已有资料与生成新内容；准确说明实际工具能力、执行结果和服务商返回的限制，不编造政策、来源或成功结果。",
  "Image could not be loaded. Open original": "图片未能加载，打开原图",
  "Site system prompt": "全站系统提示词",
  "Controls the main instructions for chats and scheduled tasks. Saved changes apply to the next request, including existing conversations. Conversation-specific instructions are kept.": "设置对话和定时任务的主要指令。保存后从下一条请求生效，已有对话也会应用；用户自定义的对话指令仍会保留。",
  "{0} / {1} characters": "{0} / {1} 字符",
  "Using built-in instructions": "正在使用内置指令",
  "Using saved instructions": "正在使用已保存的指令",
  "Save system prompt": "保存系统提示词",
  "Restore default draft": "将草稿恢复为默认值",
  "Unsaved changes": "有未保存的修改",
  "Loading system prompt…": "正在加载系统提示词…",
  "The system prompt changed in another session. Your draft is kept. Reload the saved version before editing again.": "系统提示词已在其他会话中修改。你的草稿已保留，请重新加载已保存的版本后再编辑。",
  "Could not load the system prompt. Your draft has not changed.": "系统提示词加载失败，草稿未发生变化。",
  "Could not save the system prompt. Your draft is kept; please retry.": "系统提示词保存失败，草稿已保留，请重试。",
  "Discard draft and reload": "放弃草稿并重新加载",
  "System prompt saved. It will apply to the next request.": "系统提示词已保存，将从下一条请求生效。"
}
